import { IDI_IMPORT_START_LOADING, IDI_IMPORT_END_LOADING, IDI_IMPORT_LOADED } from "../constants/IdiImportConstants";
import { postApiFormData } from "../utils/index";
import * as commonActions from "./CommonActions";

export function importIdiFile(formData, navigate) {
    return async (dispatch) => {
        await dispatch({ type: IDI_IMPORT_START_LOADING });
        try {

            var data = await postApiFormData("IdiImport/ImportExcel", null, formData);
            if(data.success) {
                await dispatch({
                    type: IDI_IMPORT_LOADED,
                    payload: data.responseEntities[0]
                });
            } else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
            await dispatch({ type: IDI_IMPORT_END_LOADING });
        } catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_IMPORT_END_LOADING });
        }
    };
}